module.exports = __webpack_public_path__ + "img/T946.da0380d5.jpg";